import React, { useMemo } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../config/authConfig';
import { Button, Stack, Alert } from '@mantine/core';
import { IconUser } from '@tabler/icons-react';
import { isMsalConfigured } from '../utils/envUtils';

export const SignInButton: React.FC = () => {
    const { instance } = useMsal();
    const msalEnabled = useMemo(() => isMsalConfigured(), []);

    const handleLogin = () => {
        if (!msalEnabled) return;
        instance.loginRedirect(loginRequest).catch(console.error);
    };

    return (
        <Stack gap="md" w="100%" maw={400} mx="auto">
            {!msalEnabled && (
                <Alert color="yellow" title="Configuration Issue">
                    MSAL sign-in is not available. Please check that environment variables are configured correctly.
                </Alert>
            )}
            <Button
                leftSection={<IconUser size={16} />}
                onClick={handleLogin}
                disabled={!msalEnabled}
                size="lg"
                fullWidth
            >
                Sign In
            </Button>
        </Stack>
    );
};
